import { SITE } from "../lib/site";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 lg:py-36 bg-[#050505]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Left — copy */}
          <div className="lg:col-span-7 reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-gold" />
              <span className="text-xs uppercase tracking-[0.32em] text-gold/90">
                Meet the Founders
              </span>
            </div>
            <h2
              data-testid="about-title"
              className="font-display font-light text-5xl lg:text-6xl leading-[1.02] tracking-tight"
            >
              Sean &amp;
              <span className="italic gold-shimmer"> Emanuel</span>.
            </h2>

            <div className="mt-8 space-y-5 text-white/70 text-lg leading-relaxed max-w-2xl">
              <p>
                Two local North Seattle high school students offering deep
                car-cleaning services at a competitive price.
              </p>
              <p>
                It all started when Sean&apos;s mom paid him to clean the
                interior of her messy &ldquo;mom-mobile.&rdquo; After plenty of
                learning on the job and practice with professional detailing
                supplies, Sean expanded his car cleaning services to friends
                and family.
              </p>
              <p>
                His good friend Emanuel jumped on board to help out, and soon
                they became the car cleaning dream team behind{" "}
                <span className="text-white">Shine and Drive</span>.
              </p>
              <p className="text-white/55">
                We put a lot of time and dedication into our car-cleaning
                craft. Schedule a car cleaning today and see for yourself.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-6 max-w-md">
              <div className="border-l border-gold/40 pl-4">
                <div className="font-display text-3xl text-gold">Local</div>
                <div className="text-xs uppercase tracking-[0.22em] text-white/60 mt-1">
                  Based in Seattle
                </div>
              </div>
              <div className="border-l border-gold/40 pl-4">
                <div className="font-display text-3xl text-gold">Detail</div>
                <div className="text-xs uppercase tracking-[0.22em] text-white/60 mt-1">
                  Done by hand
                </div>
              </div>
            </div>
          </div>

          {/* Right — founder photo */}
          <div className="lg:col-span-5 relative reveal">
            <div className="relative">
              {/* Decorative gold corner accents */}
              <div className="pointer-events-none absolute -top-3 -left-3 h-16 w-16 border-t border-l border-gold/60 z-10" />
              <div className="pointer-events-none absolute -bottom-3 -right-3 h-16 w-16 border-b border-r border-gold/60 z-10" />

              <div className="relative overflow-hidden border border-white/10 rounded-sm">
                <img
                  src={SITE.media.founders}
                  alt="Sean and Emanuel, founders of Shine & Drive Car Cleaning"
                  data-testid="about-founder-photo"
                  className="w-full h-[520px] lg:h-[620px] object-cover"
                />
                <div className="absolute inset-0 ring-1 ring-white/10 pointer-events-none" />
                {/* Bottom gradient with names */}
                <div className="absolute inset-x-0 bottom-0 p-6 pt-20 bg-gradient-to-t from-black via-black/60 to-transparent">
                  <div className="text-[10px] uppercase tracking-[0.28em] text-gold/90 mb-1">
                    Founders
                  </div>
                  <div className="font-display text-2xl text-white">
                    Sean &amp; Emanuel
                  </div>
                </div>
              </div>

              {/* Top tag removed per request */}
            </div>

            {/* Floating quote card */}
            <div className="relative lg:absolute lg:-bottom-10 lg:-left-12 mt-6 lg:mt-0 max-w-xs bg-black/85 backdrop-blur-xl border border-white/10 p-6 rounded-sm shadow-2xl">
              <p className="font-display italic text-white/90 text-lg leading-snug">
                &ldquo;Your car deserves the same care as the day you drove it
                home.&rdquo;
              </p>
              <div className="mt-4 text-xs uppercase tracking-[0.24em] text-gold">
                — Sean &amp; Emanuel
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
